const applicationRequiredStatus = {
  REQUIRED: 1,
  OPTIONAL: 0,
};

export default applicationRequiredStatus;
